export default __webpack_public_path__ + "static/aboutus6-034c412e77feb555919bb0925158bdeb.png";